import React from 'react';
import ico from '../assets/images/ico.png';
import gdc from '../assets/images/GeneralDentalCouncil.png';
import cqc from '../assets/images/Care-Quality-Commission.png';

const RegulationItem = ({ logo, description }) => {
  return (
    <div className="text-center">
      <div className="flex justify-center mb-4">
        <img src={logo} alt="Regulatory body" className="h-16" />
      </div>
      <p className="text-gray-400 text-sm">{description}</p>
    </div>
  );
};

const RegulatedBy = () => {
  const regulators = [
    {
      logo: gdc,
      description: "Our dental practices are GDC regulated, ensuring safe, effective, and high-quality patient care."
    },
    {
      logo: cqc,
      description: "Our practices are CQC regulated, prioritizing patient safety and maintaining public trust in dental care."
    },
    {
      logo: ico,
      description: "The ICO is an independent authority dedicated to protecting information rights in the public interest."
    }
  ];

  return (
    <div className="py-16 bg-neutral/10">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center font-heading mb-12">
          Regulated By
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {regulators.map((regulator, index) => (
            <RegulationItem 
              key={index}
              logo={regulator.logo}
              description={regulator.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RegulatedBy;
